const SimPlanMapping  = () => {

    return (
        <>
        <h1>Sim Plan Mapping</h1>
        </>
    )
}
export default SimPlanMapping;